import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '../../../components/button'
import Cashfree from '../../../components/cashfree'
import ChangeBankAccount from '../../../components/changeBankAccount'
import Text from '../../../components/text'
import WithdrawalReasons from '../../../components/withdrawalReasons'
import { useAxios } from '../../../core/AxiosContext'
import { useGlobal, useGlobalDispatch } from '../../../core/GlobalContext'
import { REQUEST_STATUS, ROUTES } from '../../../core/actions'
import { INR, TRADECRED_SUPPORT_EMAIL } from '../../../core/constants'
import { currencyParser } from '../../../utils/misc'
import { fetchWalletAction } from '../../financier/FinancierDuck'
import * as styles from '../deposit/Deposit.css'

export const Withdraw = () => {
  const { authAxios } = useAxios()
  const {
    financierState: { financier },
    overviewState: { cashfreeStatus, cashfreeType },
  } = useGlobal()
  const { financierDispatch } = useGlobalDispatch()
  const navigate = useNavigate()

  const [withdrawalReason, setWithdrawalReason] = useState()

  const handleBackPress = () => navigate(ROUTES.OVERVIEW)

  useEffect(() => {
    fetchWalletAction()(authAxios, financierDispatch)
  }, [])

  // Refresh wallet balance after successful withdrawal
  useEffect(() => {
    if (cashfreeType === 'WITHDRAW' && cashfreeStatus === REQUEST_STATUS.SUCCESS) {
      fetchWalletAction()(authAxios, financierDispatch)
    }
  }, [cashfreeStatus, cashfreeType, authAxios, financierDispatch])

  return (
    <div className={styles.deposit}>
      <div className={styles.header}>
        <Button handleClick={handleBackPress} type='icon'>
          <ion-icon name='arrow-back-outline' />
        </Button>
        <Text size='1.5' color='var(--ib-ink)' bold className={styles.title}>
          Withdraw {INR} from wallet
        </Text>
      </div>
      <Text size='0.8' color='var(--ib-muted)' className={styles.subLine}>
        Withdraw money from your Escrow Account (Income Bazaar Wallet) to your registered Bank Account
      </Text>
      <div className={styles.divider} />

      {financier?.financierBank?.accountNumber ? (
        <div className={styles.depositDetails}>
          <div className={styles.escrowCard}>
            <span className={styles.escrowTitle}>Credit to Your Bank Account</span>
            <div className={styles.attrGrid}>
              <div className={styles.attr}>
                <span className={styles.attrLabel}>Account Number</span>
                <span className={styles.attrValue}>{financier?.financierBank?.accountNumber}</span>
              </div>
              <div className={styles.attr}>
                <span className={styles.attrLabel}>Bank Name</span>
                <span className={styles.attrValue}>{financier?.financierBank?.bankName}</span>
              </div>
              <div className={styles.attr}>
                <span className={styles.attrLabel}>IFSC</span>
                <span className={styles.attrValue}>{financier?.financierBank?.IFSC}</span>
              </div>
            </div>
          </div>

          <div className={styles.availableBalance}>
            <span className={styles.balanceLabel}>Available Wallet Balance</span>
            <span className={styles.balanceValue}>{currencyParser(financier?.walletBalance)}</span>
          </div>

          <span className={styles.fieldLabel}>Enter amount to withdraw</span>
          <div className={styles.amountRow}>
            <Cashfree type='Withdraw' enabled={withdrawalReason} withdrawalReason={withdrawalReason} />
          </div>
          <WithdrawalReasons setWithdrawalReason={setWithdrawalReason} />
          <div className={styles.divider} />

          <Text size='0.8' color='var(--ib-muted)' className={styles.footerNote}>
            In case the amount is not credited within 48 hours, please reach out to us at {TRADECRED_SUPPORT_EMAIL}{' '}
            before raising dispute with your bank.
          </Text>
        </div>
      ) : (
        <div className={styles.depositDetails}>
          <Text size='0.9' color='var(--ib-ink)' className={styles.instr}>
            We haven&apos;t received your bank account details yet. Please provide the same in order to process
            withdrawals.
          </Text>
          <div className={styles.changeBankAccount}>
            <ChangeBankAccount />
          </div>
        </div>
      )}
    </div>
  )
}
